module.exports = __webpack_public_path__ + "img/p1-pic@2x.606c519c.jpg";